// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2308":"cda0e646","6172":"cda0e646","6178":"1735680d","6255":"cda0e646","9838":"cda0e646"}[chunkId] + ".chunk.css";
};